import DashboardLayout from "../../lib/components/layouts/dashboard";
import { Col, Image, Row } from "react-bootstrap";

import DashboardWidget from "lib/components/common/dashboard/dashboard-widget";
import ClinicsPanel from "lib/components/common/dashboard/clinics-panel";
import { useNavigate } from "react-router-dom";
import useDashboard from "lib/hooks/useDashboard";
import { useContext, useEffect } from "react";
import LoadingBox from "lib/components/common/loading-box";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { ASSETS } from "assets";
import { AppContext } from "lib/contexts/app-context";
import SimpleGreeting from "lib/components/common/simple-greeting";

const BreadcrumbItems = [
  {
    label: "Dashboard",
    path: PAGE_ROUTES.ADMIN.Dashboard,
  },
] as BreadcrumbItem[];

const AdminDashboard = () => {
  const { getDashboardWidgetData, dashboardWidgets, loading, error } =
    useDashboard();
  const navigate = useNavigate();
  const handleWidgetClick = (path: string) => {
    navigate(path);
  };
  const { appState } = useContext(AppContext);

  useEffect(() => {
    getDashboardWidgetData();
  }, []);

  return (
    <DashboardLayout breadcrumbItems={BreadcrumbItems}>
      <div className="good-morning-blk">
        <Row>
          <Col md={8}>
            <div className="morning-user">
              <SimpleGreeting name={appState?.name} />
              <p>Have a nice day at work</p>
            </div>
          </Col>
          <Col md={4}>
            <div className="morning-img">
              <Image src={ASSETS.IMAGES.ADMIN_DASHBOARD_LOGO} alt="" />
            </div>
          </Col>
        </Row>
      </div>
      <Row>
        <Col sm={12}>
          <ClinicsPanel/>
        </Col>
      </Row>
    </DashboardLayout>
  );
};

export default AdminDashboard;
